import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Login from "@/pages/Login";
import OrdersPage from "@/pages/OrdersPage";
import Reports from "@/pages/Reports";
import Users from "@/pages/Users";
import Customers from "@/pages/Customers";
import CourierPanel from "@/pages/CourierPanel";
import { Toaster } from "@/components/ui/sonner";

function Loading() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-white">
      <div data-testid="auth-loading" className="font-mono text-xs uppercase tracking-[0.3em] text-zinc-500">
        Yükleniyor…
      </div>
    </div>
  );
}

function defaultRouteForRole(role) {
  if (role === "kurye") return "/courier";
  return "/orders";
}

function ProtectedRoute({ children, roles }) {
  const { user } = useAuth();
  if (user === null) return <Loading />;
  if (!user) return <Navigate to="/login" replace />;
  if (roles && !roles.includes(user.role)) {
    return <Navigate to={defaultRouteForRole(user.role)} replace />;
  }
  return children;
}

function RootRedirect() {
  const { user } = useAuth();
  if (user === null) return <Loading />;
  if (!user) return <Navigate to="/login" replace />;
  return <Navigate to={defaultRouteForRole(user.role)} replace />;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<RootRedirect />} />
            <Route path="/login" element={<Login />} />
            <Route
              path="/orders"
              element={
                <ProtectedRoute roles={["admin", "personel"]}>
                  <OrdersPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/reports"
              element={
                <ProtectedRoute roles={["admin"]}>
                  <Reports />
                </ProtectedRoute>
              }
            />
            <Route
              path="/users"
              element={
                <ProtectedRoute roles={["admin"]}>
                  <Users />
                </ProtectedRoute>
              }
            />
            <Route
              path="/customers"
              element={
                <ProtectedRoute roles={["admin", "personel"]}>
                  <Customers />
                </ProtectedRoute>
              }
            />
            <Route
              path="/courier"
              element={
                <ProtectedRoute roles={["kurye"]}>
                  <CourierPanel />
                </ProtectedRoute>
              }
            />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster richColors position="top-center" />
      </AuthProvider>
    </div>
  );
}

export default App;
